import * as React from "react"

import { cn } from "@/shared/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-11 w-full min-w-0 rounded-lg border border-[var(--color-border)] bg-[var(--color-brand-50)] px-3 text-center text-[0.95rem] leading-[1.65] text-[var(--color-text-primary)] shadow-sm transition placeholder:text-[var(--color-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)] disabled:pointer-events-none disabled:opacity-60 md:text-sm",
        "file:inline-flex file:h-8 file:rounded-md file:border-0 file:bg-[var(--color-surface-muted)] file:px-3 file:text-sm file:font-medium",
        "aria-invalid:border-[var(--color-error-border)] aria-invalid:text-[var(--color-text-primary)] aria-invalid:focus-visible:ring-[var(--color-error)]",
        className,
      )}
      {...props}
    />
  )
}

export { Input }
